import { jsx } from 'react/jsx-runtime';
import styles from './Divider.module.css.js';

function Divider() {
    return jsx("hr", { className: styles.divider });
}

export { Divider };
//# sourceMappingURL=Divider.js.map
